import avtar from "../../assets/images/default-avatar.jpg"
// const initialState = {
//   profileImage:  localStorage.getItem("profileImage")
//     ?? avtar,

//   defaultLanguage:
//   {
//     id: 1,
//     name: "English",
//     code: "en",
//     status: "ACTIVE",
//     is_published: 1
//   }
// };

const initialState = {
  profile: {
    profileImage: localStorage.getItem("profileImage") || avtar,
    defaultLanguage: {
      id: 1,
      name: "English",
      code: "en",
      status: "ACTIVE",
      is_published: 1,
    },
    manage_question_filters: {
      level: "",
      status: "",
      queType: "",
      selectedSkill: "",
      keyword: "",
      page: 1
    },
    pagination: {
      paginationSize: 10
    }
  },
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_PROFILE_IMAGE":
      return {
        ...state,
        profileImage: action.payload,
      }

    case "UPDATE_LANGAUGE":
      return {
        ...state,
        defaultLanguage: action.payload,
      }

    case "UPDATE_QUESTION_FILTERS":
      return {
        ...state,
        manage_question_filters: action.payload,
      }

    case "UPDATE_PAGINATION_SIZE":
      return {
        ...state,
        pagination: action.payload,
      }

    default:
      return state
  }
};

export default profileReducer;

